var map = {
	"./projects/convocatoria/convocatoria.module": [
		"./src/app/projects/convocatoria/convocatoria.module.ts",
		"projects-convocatoria-convocatoria-module"
	],
	"./projects/encuestas/encuestas.module": [
		"./src/app/projects/encuestas/encuestas.module.ts",
		"default~projects-encuestas-encuestas-module~projects-personal-personal-module",
		"projects-encuestas-encuestas-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;